import kr from '../kr/kr';

export default class GaEventPush extends kr.Module
{
    init()
    {
        this.$ = window.jQuery;

        this.formsNames = {
            2996 : 'Ask Question',
            3057 : 'Service help',
            9151 : 'Product Ask Question'
        }
        if (typeof window.gtag === 'undefined') {
            return
        }
        this.dataLayer = window.dataLayer;

        this.bind();
    }

    bind()
    {
        const self = this;
        this.$('body').on('click', '[data-gtag-event][data-gtag-product]', function(event) {
            
            self._pushProduct(
                this.getAttribute('data-gtag-event'),
                this.getAttribute('data-gtag-product')
            );
            return true;
        });

        // contact form 7

        //document.addEventListener( 'wpcf7mailsent', function( event ) {
        document.addEventListener( 'wpcf7invalid', event => {
            if (typeof event.detail.contactFormId === 'undefined') {
                return
            }
            
            const name = this.formsNames[event.detail.contactFormId] ?? 'unknown';
            const product = this.$('input[name="product-from-product-name"]').val();
            
            this._pushProduct(
                `Send ${name}`,
                product
            )
        }); 
    }


    _pushProduct(evt, product)
    {
        const obj = {
            event: evt,
            product: product
        }
        this.dataLayer.push(obj);
    }
}